import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureDatabricksDeltaLakeSink } from 'app/model/pipeline/copysink/azure-databricks-delta-lake.copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from '../../value.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDatabricksDeltaLakeSink),
    asynchronous: true,
    adapts: {
        type: '*',
        preCopyScript: '*',
        importSettings: {
            type: '*',
            dateFormat: '*',
            timestampFormat: '*'
        }
    }
})
export class AzureDatabricksDeltaLakeSinkAdapter extends CopySinkAdapter<
    AzureDatabricksDeltaLakeSink,
    Model.AzureDatabricksDeltaLakeSink
> {
    protected override async _toResource(
        model: AzureDatabricksDeltaLakeSink
    ): Promise<Model.AzureDatabricksDeltaLakeSink> {
        const result: Model.AzureDatabricksDeltaLakeSink = {
            type: adfModelTypeMap.azureDatabricksDeltaLake.copySinkType
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.importSettings = { type: 'AzureDatabricksDeltaLakeImportCommand' };
        result.importSettings.dateFormat =
            ValueAdapter.toResource(model, AzureDatabricksDeltaLakeSink.DATE_FORMAT) || undefined;
        result.importSettings.timestampFormat =
            ValueAdapter.toResource(model, AzureDatabricksDeltaLakeSink.TIMESTAMP_FORMAT) || undefined;
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureDatabricksDeltaLakeSink,
        owner: Activity
    ): Promise<AzureDatabricksDeltaLakeSink> {
        const result = Owned.create<AzureDatabricksDeltaLakeSink>(
            Metamodel.modelFor(AzureDatabricksDeltaLakeSink),
            owner
        );
        TabularSinkAdapter.toSinkModel(resource, result);
        const importSettings = resource.importSettings;
        if (importSettings != null) {
            ValueAdapter.toModel(result, AzureDatabricksDeltaLakeSink.DATE_FORMAT, importSettings.dateFormat);
            ValueAdapter.toModel(result, AzureDatabricksDeltaLakeSink.TIMESTAMP_FORMAT, importSettings.timestampFormat);
        }
        return result;
    }
}
